import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Loader } from '../../../UiKit';

const GoogleLoginButtonV2 = ({
  loading = false,
  onSuccess,
  onError,
  disabled = false,
}) => {
  return (
    <div
      data-dd-privacy='hidden'
      className={`tw-flex tw-justify-center ${
        disabled
          ? 'tw-opacity-65 tw-grayscale !tw-cursor-not-allowed tw-pointer-events-none'
          : ''
      }`}
    >
      {loading ? (
        <div className='tw-border tw-border-solid tw-flex tw-justify-center tw-border-grey-300 tw-rounded-lg tw-py-[0.7rem] tw-w-[18rem]'>
          <Loader size='medium' />
        </div>
      ) : (
        <GoogleLogin
          onSuccess={onSuccess}
          onError={onError}
          useOneTap={true}
          auto_select={true}
          logo_alignment='center'
        />
      )}
    </div>
  );
};

export default GoogleLoginButtonV2;
